// ============================================================
// addform.js — Formulaire d'ajout d'un nouveau parc
// Composant de classe contrôlé : toutes les valeurs des champs
// sont stockées dans le state React (pas dans le DOM).
// À la soumission, envoie un POST /add/ avec le token Auth0.
// Props :
//   authtoken — token Bearer Auth0 (peut être une Promise)
//   onRefresh — callback pour recharger la liste des parcs
//   onHide    — callback pour fermer la modale
// ============================================================

import React, { Component } from 'react'
import { Form, Button } from 'react-bootstrap';
import axios from 'axios';

class FormPark extends Component {
    constructor(props) {
        super(props)
        // État initial : champs vides, pas d'erreur, URL invalide
        this.state = {
            ControlDate: null,   // Date du premier contrôle (YYYY-MM-DD)
            name: '',            // Nom du parc
            URL: '',             // URL Google Maps
            lat: 0,              // Latitude extraite de l'URL
            lng: 0,              // Longitude extraite de l'URL
            URLError:"",         // Message d'erreur affiché sous le champ URL
            nameError: "",       // (réservé) message erreur nom
            ControlDateError: "", // (réservé) message erreur date
            URLValid: false,     // true = coordonnées extraites avec succès
            userControlId: 0, // Expert ayant effectué le contrôle
            }

        this.handleChange = this.handleChange.bind(this)
        this.handleURL = this.handleURL.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    };

    // Soumission du formulaire : bloque le rechargement natif,
    // vérifie que l'URL est valide, puis envoie les données à l'API.
    // En cas de succès : rafraîchit la liste et ferme la modale.
    handleSubmit = async event => {
        event.preventDefault()
        if(this.state.URLValid === true){
            const userControlId = parseInt(this.selectedExpertId(), 10)
            Promise.resolve(this.props.authtoken).then((token) => {
                axios.post('/add/', { name: this.state.name, URL: this.state.URL, lat: this.state.lat, lng: this.state.lng, ControlDate: this.state.ControlDate, userControlId: userControlId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(() => {
                    if (this.props.onRefresh) this.props.onRefresh();
                    if (this.props.onHide) this.props.onHide();
                })
                .catch(err => {
                    console.error('Erreur ajout parc:', err)
                    // Affiche la raison du refus renvoyée par le serveur (validation)
                    const data = err.response && err.response.data
                    const details = data && data.errors ? data.errors.join('\n') : (data && data.error) || err.message
                    alert("Ajout refusé :\n" + details)
                })
            })
        }
        else {
            // L'URL n'a pas pu être validée — informe l'utilisateur
            alert("veuillez verifier votre URL")
        }
    }

    // Expert sélectionné : tant que l'utilisateur n'a pas touché la liste,
    // c'est le premier expert affiché (onChange n'est pas déclenché).
    selectedExpertId() {
        const experts = this.props.experts || []
        return this.state.userControlId || (experts[0] && experts[0].id) || 0
    }

    // Gestionnaire générique pour tous les champs texte/date/select :
    // utilise le "computed property name" (ES6) pour mettre à jour
    // dynamiquement la bonne clé du state selon le name du champ.
    handleChange = event => {
        this.setState({
            // La clé est le "name" de l'input (name, ControlDate, userControl, etc.)
            [event.target.name]: event.target.value
        })
    }

    // Gestionnaire spécifique pour le champ URL Google Maps :
    // extrait la latitude et longitude selon deux formats possibles,
    // puis met à jour le state (URLValid, lat, lng, URLError).
    handleURL = async event => {
        var URL = event.target.value;
        if(URL.toString().includes('google.com/maps') || URL.toString().includes('google.fr/maps')) {
            let Lat = null, Lng = null;

            // Format 1 : https://maps.google.com/.../place/Nom/@lat,lng,zoom/...
            // Les coordonnées se trouvent après le caractère '@'
            if (URL.includes('@')) {
                const atPart = URL.split('@')[1];
                if (atPart) {
                    Lat = atPart.split(',')[0];
                    Lng = atPart.split(',')[1];
                }
            }

            // Format 2 : coordonnées encodées dans le paramètre data
            // sous la forme !3d<lat>!4d<lng> (nouveau format Google Maps)
            if (!Lat || !Lng) {
                const latMatch = URL.match(/!3d(-?\d+\.\d+)/);
                const lngMatch = URL.match(/!4d(-?\d+\.\d+)/);
                if (latMatch && lngMatch) {
                    Lat = latMatch[1];
                    Lng = lngMatch[1];
                }
            }

            if (Lat && Lng) {
                // Coordonnées extraites : URL valide
                this.setState({ URL: URL, lat: Lat, lng: Lng, URLValid: true, URLError: "" });
            } else {
                // URL Google Maps reconnue mais coordonnées introuvables
                this.setState({ URLError: "Impossible d'extraire les coordonnées depuis cette URL", URLValid: false });
            }
        }
        else{
            // URL qui n'est pas un lien Google Maps
            this.setState({ URLError:"l'URL n'est pas une URL Google Maps", URLValid: false })
        }
    }

    // Rendu du formulaire contrôlé.
    // Chaque champ est lié au state via onChange (handleChange ou handleURL).
    render (){
        return (
            <Form id="formid" onSubmit={this.handleSubmit}>
                {/* Champ nom du parc */}
                <Form.Group>
                    <Form.Label>Nom</Form.Label>
                    <Form.Control
                        required
                        name="name"
                        type="string"
                        onChange={this.handleChange}
                    />
                </Form.Group>

                {/* Champ date du premier contrôle */}
                <Form.Group>
                    <Form.Label>Date de premier controle</Form.Label>
                    <Form.Control
                        required
                        name="ControlDate"
                        type="date"
                        onChange={this.handleChange}
                    />
                </Form.Group>

                {/* Sélecteur de l'expert ayant effectué le contrôle */}
                <Form.Group>
                    <Form.Label>Controle fait par:</Form.Label>
                    <Form.Control
                        onChange={this.handleChange}
                        as="select"
                        name="userControlId"
                        value={this.selectedExpertId()}
                        className="rounded-0 shadow dateControl">
                        {(this.props.experts || []).map(function(e) {
                            return <option key={e.id} value={e.id}>{e.name}</option>;
                        })}
                    </Form.Control>
                </Form.Group>

                {/* Champ URL Google Maps avec validation et affichage des coordonnées */}
                <Form.Group>
                    <Form.Label>URL</Form.Label>
                    <Form.Control
                        required
                        name="URL"
                        type="string"
                        onChange={this.handleURL}
                        />
                    {/* Message d'erreur si l'URL est invalide ou sans coordonnées */}
                    <div style={{color: "red", fontSize: 12}}>{this.state.URLError}</div>
                    {/* Confirmation verte avec lat/lng si l'URL est valide */}
                    {this.state.URLValid && (
                        <div style={{color: "green", fontSize: 12, marginTop: 4}}>
                            Lat : {this.state.lat} — Lng : {this.state.lng}
                        </div>
                    )}
                </Form.Group>

                {/* Bouton de soumission */}
                <Button style={{ margin: "5px" }} variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Form>
        )
    }
}

export default FormPark
